import React, { Component } from 'react';
import axios from 'axios';

import { langCodeTA } from 'utils/currentLanguage';

import { backendUrl, basicAuth } from 'utils/constantsHelper';
import Loader from 'components/Loader';

export const withTechnicalBulletin = (WrappedComponent) => {
  return class extends Component {
    constructor() {
      super();

      this.state = {
        statusCode: null,
        loading: true,
        dataBulletins: [],
      };
    }

    getData = () => {
      axios({
        method: 'get',
        url:
          backendUrl +
          langCodeTA +
          '/api/v1/content?_format=json&product_id=' +
          this.props.articleNo,
        headers: {
          ...basicAuth,
        },
      })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.hasOwnProperty('content')) {
              this.setState({
                loading: false,
                dataBulletins: [],
              });
            } else {
              this.setState({
                loading: false,
                dataBulletins: response.data,
              });
            }
          }
        })
        .catch(() => {
          this.setState({
            loading: false,
          });
        });
    };

    componentDidMount() {
      this.getData();
    }

    render() {
      if (this.state.loading) {
        return <Loader />;
      }

      return (
        <WrappedComponent
          dataBulletins={this.state.dataBulletins}
          loading={this.state.loading}
          {...this.props}
        />
      );
    }
  };
};



// WEBPACK FOOTER //
// ./src/containers/withTechnicalBulletin/withTechnicalBulletin.js